import { InputChoice } from 'components/formInputs/types';
import range from 'utils/range';

import { OccupationFormValues } from './types';

export const WORK_FROM_HOME_PERCENTAGES = range(0, 100, 10).map((value) => ({
  label: `${value}%`,
  value,
}));

export const CORPORATE_STRUCTURES = [
  { label: 'C-corp', value: 'c_corp' },
  { label: 'S-corp', value: 's_corp' },
  { label: 'Limited Liability Corporation (LLC)', value: 'llc' },
  { label: 'Limited Liability Partnership (LLP)', value: 'llp' },
  { label: 'Professional Corporation (PC)', value: 'pc' },
  { label: 'Sole proprietorship', value: 'sole_proprietorship' },
];

export const OWNERSHIP_STAKES = range(0, 100).map((value) => ({
  label: `${value}%`,
  value,
}));

export const EDUCATION_LEVELS = [
  { label: 'High School', value: 'high_school' },
  { label: "Associates's Degree", value: 'associates_degree' },
  { label: "Bachelors's Degree", value: 'bachelors_degree' },
  { label: "Master's Degree", value: 'masters_degree' },
  { label: 'JD or MD', value: 'jd_or_md' },
  { label: 'PhD', value: 'phd' },
];

export const DISABILITY_INSURANCE_SOURCES = [
  { label: 'Covered by my employer', value: 'employer' },
  { label: 'Bought my own policy', value: 'own' },
  { label: 'I have both employer-provided coverage and a policy I bought myself', value: 'combo' },
];

export const INTEND_TO_REPLACE_OPTIONS: Array<InputChoice<string>> = [
  { label: 'Yes', value: 'true' },
  { label: 'No, this is supplementary coverage', value: 'false' },
];

export const LABELS: Record<keyof OccupationFormValues, string> = {
  annualIncomeBeforeCompany: 'What was your annual income before you started this company?',
  atLeast30HoursAWeek: 'Do you work at least 30 hours / week in this occupation?',
  becameOwnerAt: 'Became owner/partner in',
  companyFoundedAt: 'Company founded in',
  corporateStructure: 'Corporate structure',
  disabilityInsuranceSource: 'What type of disability coverage do you have?',
  disabilityInsuranceStatus: 'Do you have existing coverage?',
  educationLevel: 'What is your highest level of education completed?',
  employerPaysPremium: 'Does your employer pay the insurance premium?',
  existingCoverage: 'Existing coverage (enter monthly benefit amount)',
  governmentEmployee: 'Are you a government employee (local, state, or federal)?',
  individualIncome: 'Your individual annual income',
  intendToReplace: 'Do you intend to replace your existing coverage?',
  job: "What's your occupation? (select the best match)",
  numberOfEmployees: 'Number of employees',
  numberOfPartners: 'Number of partners / co-owners',
  ownershipStake: 'What is your ownership stake?',
  selfEmployed: 'Are you self-employed or a business owner?',
  workFromHomePercentage: 'Percentage of time you work at home',
  yearsOfExperience: 'How many years have you worked in this occupation?',
};
